﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { ListasValoresItemsDef } from "./ListasValoresItemsDef";

export class ListasValoresItems extends Entity<ListasValoresItemsDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ListasValoresItemsDef(), parentKeys);
       // super.Form = import('./ListasValoresItemsForm').then((module) => module.ListasValoresItemsForm);
        this.Title = "Listas Valores Items";
    }
}